import { getUserInternalAccessToken } from "@/api/access-token-backoffice";
import { apiBackofficeT2b } from "@/lib/axios";

import { SalesProductPrice } from "./get-all-sales-product-prices";

export async function getSalesProductPriceById(id: number): Promise<SalesProductPrice> {
  const { accessToken } = await getUserInternalAccessToken();

  const config = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };

  // Usar a mesma API do backoffice (padrão do projeto)
  const response = await apiBackofficeT2b.get<SalesProductPrice>(
    `/v1/salesproductprice/${id}`,
    config
  );

  return response.data;
}
